<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-07-27 15:10:09
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-08-12 16:01:30
 * @FilePath: \ces-vue-serve\src\views\orderPersion\handler\service\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <base-info ref="baseInfo" v-model="form" v-loading="loading" />
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        合同附件信息
      </div>
      <div class="rj-page-card__content">
        <contract-file v-if="form.id" :contract-num="form.id" />
      </div>
    </div>
    <product-list ref="product" :is-test-project="form.isTestProject" :rebate-amount="form.rebateAmount" :sales-type="form.salesType" :rebate="form.rebate" :contract-type="form.contractType" :form="form" @chooseAddress="(val)=>{form.receiptAddressId=val.id}" />
    <actions :id="form.id" />
  </div>
</template>
<script type="es6">
import actions from '../actions';
import baseInfo from './baseInfo';
import productList from '../productList';
import contractFile from '../../../Chief/contract/common/contractFile';
import axios, { getContractDetailAllInfoByConNum, getContractProductInfoByContractId, getReceiptAddressByContractId } from '@/API';
import actionMixin from '../actionMixin';
export default {
  mixins: [actionMixin],
  data () {
    return {
      form: {
      },
      loading: false
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    baseInfo,
    productList,
    actions,
    contractFile
  },
  computed: {},
  methods: {
    initData () {
      this.loading = true;
      getContractDetailAllInfoByConNum(this.contractNum).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.form = json.data;
          this.$nextTick(() => {
            this.$refs.baseInfo.setInitData();
            this.initProduct();
          });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    initProduct () {
      this.productLoading = true;
      axios.all([
        getContractProductInfoByContractId(this.form.id),
        getReceiptAddressByContractId(this.form.id)
      ]).then((res) => {
        let fjson = res[0].data;
        let sjson = res[1].data;
        this.productLoading = false;
        if (fjson.status === '200') {
          this.$refs.product.productList = fjson.data;
          // 让表格重新计算高度，防止合计被fixed属性破坏宽度
          this.$nextTick(() => {
            if (fjson.data.length > 10) {
              this.$refs.product.tableHeight = 500;
            } else {
              this.$refs.product.tableHeight = '';
            }
          });
        }
        if (sjson.status === '200') {
          this.$refs.product.address = sjson.data;
        }
        if (this.form.contractType === '服务订单') {
          this.$refs.product.productList.forEach((item) => {
            item.productNum = item.serviceLife;
          });
        }
      }).catch(() => {
        this.productLoading = false;
      });
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
<style lang="scss" scoped>
</style>
